export default "__VITE_ASSET__gSmT1vV8__"